import {Component} from "@angular/core";

@Component({
    selector: "fui-field",
    styleUrls: ["./field.component.scss"],
    templateUrl: "./field.component.html",
    standalone: false
})
export class FUIFieldComponent {
}
